import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { OnlyBackButton } from '../../../components/base/BottomStepComponent';
import ContentSections from '../../../components/base/ContentSections';
import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import CustomListComponent from '../../../components/base/CustomListComponent';
import MembershipInfoCard from '../../../components/customer/MembershipInfoCard';
import { getRecordsRelatedTransactionCard } from '../pointRecords/PointTransactionOverview';
import { recordType } from '../../../models/StampRecordModel';
import { createAction } from 'utils';
import LimitInfoField from 'components/limitInfo/LimitInfoField';

function StampRecordDetail({ stampRecord }) {
  const history = useHistory();
  const params = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: 'stampRecord/getOneDetail',
      payload: {
        id: params.id,
      },
    });
    return () => dispatch(createAction("stampRecord/clearData")())
  }, [dispatch, params.id]);

  const getStampDetailSectionFieldsWithType = (recordType) => {
    let extraFields = [];
    if (recordType === 'STAMP_EXPIRED') {
      extraFields = extraFields.concat([
        [{ title: 'Expiry date', field: 'createDate' }],
      ]);
    }
    return [
      [{ title: 'Quantity', field: 'quantity' }],
      [{ title: 'Remarks (optional)', field: 'remark' }],
      ...extraFields,
    ];
  };

  const tabs = [
    {
      name: '',
      content: (
        <div className="scroll-container-common">
          <ContentSections
            sections={[
              <MembershipInfoCard
                title={'STAMP RECORD DETAILS'}
                data={stampRecord}
                fields={[
                  [{ title: 'Customer', field: 'name', customerLink: true }],
                  [{ title: 'Membership ID', field: 'membershipId' }],
                  [{ title: 'Event Type', field: 'displayEventType' }],
                  [{ title: 'Record Type', field: 'displayRecordType' }],
                  [{ title: 'Quantity', field: 'displayQuantity' }],
                  [{ title: 'Campaign', field: 'displayCampaignInfo', deeplink: stampRecord?.campaignLink }],
                  [{ title: 'Task Name', field: 'displayTaskNameInfo' }],
                  [{ title: 'Remarks (optional)', field: 'remark' }],
                  [{ title: 'Creation date', field: 'detailDisplayCreationDate' }],
                ].concat(
                  [
                    recordType.ADMIN_REMOVE,
                    recordType.ADMIN_ADD,
                    recordType.MERCHANT_REMOVE,
                    recordType.MERCHANT_ADD,
                    recordType.ADMIN_TRANSFERRED
                  ].includes(stampRecord?.displayRecordType)
                    ? [
                      [
                        {
                          title: 'Admin User',
                          field: 'displayAdministrator',
                        },
                      ],
                    ]
                    : [],
                )}
              />,
              ...(stampRecord?.transaction?.pk ? [
                getRecordsRelatedTransactionCard(stampRecord.transaction)
              ] : []),
              ...stampRecord?.reachLimitInfo?.reachLimit
                ? [
                  <LimitInfoField
                    title="REWARD REACHED LIMIT"
                    reachLimitInfo={stampRecord?.reachLimitInfo}
                  />
                ]
                : [],
            ]}
            hidePreview={true}
          />
        </div>
      ),
    },
  ];
  return (
    <>
      <CustomListComponent
        caution={{
          detail: '',
          title: 'Stamp record details'
        }}
        breadcrumb={<CustomBreadcrumb />}
        hideTab={true}
        tabs={tabs}
        buttons={[]}
      />
      <OnlyBackButton
        backAction={() => {
          history.push({
            pathname: '/stamp_records',
          });
        }}
      />
    </>
  );
}
const mapPropsToState = (state) => ({
  stampRecord: state.stampRecord.detail,
});

export default connect(mapPropsToState)(StampRecordDetail);
